import { useEffect } from 'react';

/**
 * @effect Disables body scrolling if the modal is open
 * @param isOpen If the modal is open
 */
const useModalHook = (isOpen?: boolean) => {
  // Disables body scrolling when modal is open
  useEffect(() => {
    const body = document.querySelector('body');

    if (!body) return () => null;

    body.style.overflow = isOpen ? 'hidden' : 'auto';

    return () => {
      body.style.overflow = 'auto';
    };
  }, [isOpen]);
};

export default useModalHook;
